<dx-popup
  [visible]="true"
  [fullScreen]="true"
  [showTitle]="false"
  [showCloseButton]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [wrapperAttr]="{ class: 'comparison-pdf-preview' }"
  (onHidden)="close()"
>
  <!--
    The template's own element is DevExtreme's wrapper, which sets its display itself, so the
    layout lives one level down.
  -->
  <div *dxTemplate="let data of 'content'" class="comparison-pdf-preview__content">
    <div class="comparison-pdf-preview__shell">
      <div class="comparison-pdf-preview__toolbar">
        <button type="button" class="comparison-pdf-preview__back-button" (click)="close()">
          <span aria-hidden="true">←</span>
          <span>Back to dashboard</span>
        </button>

        <div class="comparison-pdf-preview__heading">
          <span class="comparison-pdf-preview__title" [title]="title">{{ title }}</span>
          <span class="comparison-pdf-preview__pill">PDF</span>
        </div>

        <ag-shr-report-pdf-actions
          class="comparison-pdf-preview__download"
          [pdfBlob]="pdfUrlSig() ? pdfBlob : null"
          [fileName]="fileName"
          [disabled]="isLoadingSig()"
        ></ag-shr-report-pdf-actions>
      </div>

      <div #previewBody class="comparison-pdf-preview__body">
        @if (errorMessageSig(); as errorMessage) {
          <div class="comparison-pdf-preview__error">
            <p>{{ errorMessage }}</p>
            <dx-button text="Try again" stylingMode="outlined" (onClick)="retry()"></dx-button>
          </div>
        } @else {
          @if (pdfUrlSig(); as pdfUrl) {
            <iframe class="comparison-pdf-preview__frame" [src]="pdfUrl" [title]="title + ' PDF preview'"></iframe>
          }
        }

        <dx-load-panel
          [visible]="isLoadingSig()"
          [showIndicator]="true"
          [showPane]="true"
          [shading]="false"
          [hideOnOutsideClick]="false"
          [container]="previewBody"
          [position]="{ my: 'center', at: 'center', of: previewBody }"
          message="Building the PDF..."
        ></dx-load-panel>
      </div>

      <!-- The same floating panel the bulletin viewer carries: beside the document, not over it. -->
      <ag-shr-report-settings-popup [title]="'PDF Contents'" [anchorSelector]="'.comparison-pdf-preview__body'">
        <div class="comparison-pdf-preview__settings">
          @for (group of blockGroups; track group.title) {
            <div class="comparison-pdf-preview__group">
              <dx-check-box
                class="comparison-pdf-preview__group-toggle"
                [text]="group.title"
                [value]="getGroupValue(group)"
                (onValueChanged)="onGroupValueChanged(group, $event)"
              ></dx-check-box>
              @for (block of group.blocks; track block.id) {
                <dx-check-box
                  class="comparison-pdf-preview__block"
                  [text]="block.label"
                  [value]="isSelected(block.id)"
                  (onValueChanged)="onBlockValueChanged(block.id, $event)"
                ></dx-check-box>
              }
            </div>
          }

          <p class="comparison-pdf-preview__hint">
            Tables print with the columns, sort, filters and rows they have on the dashboard.
          </p>

          <div class="comparison-pdf-preview__actions">
            <button
              type="button"
              class="ag-shr-report-settings-popup__primary-button"
              [disabled]="!canApplySig()"
              (click)="apply()"
            >
              {{ isLoadingSig() ? "Working..." : "Apply" }}
            </button>
            <button
              type="button"
              class="ag-shr-report-settings-popup__secondary-button"
              [disabled]="!hasChangesSig() || isLoadingSig()"
              (click)="discard()"
            >
              Discard
            </button>
          </div>
        </div>
      </ag-shr-report-settings-popup>
    </div>
  </div>
</dx-popup>
